import { render, staticRenderFns } from "./delivery_campaings.vue?vue&type=template&id=2ecb2a95&scoped=true"
import script from "./delivery_campaings.vue?vue&type=script&lang=js"
export * from "./delivery_campaings.vue?vue&type=script&lang=js"
import style0 from "./delivery_campaings.vue?vue&type=style&index=0&id=2ecb2a95&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecb2a95",
  null
  
)

export default component.exports